export default __webpack_public_path__ + "static/shipping-4fadca1a506812ebd2355102f17bb7a9.jpg";